import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { bp } from 'Styles/helpers';
import screen from 'superior-mq';
import Container from '../../container';
import PartnerGrid from '../../partner-grid';
import HeroTextWave from '../../hero-text-wave';
import Button from '../../button';

const PartnersSection = ({ title, description, partnerList }) => {

  const scrollToPartners = () => {
    TweenMax.to(window, 0.8, {
      scrollTo: { y: '#become-a-partner', offsetY: 50, autoKill: false },
      ease: Power2.easeOut,
    });
  };

  return (
    <Section>
      <Container>
        <HeroTextWave>
          <h1>{title}</h1>
        </HeroTextWave>
        <p>{description}</p>
        <PartnerButton onClick={scrollToPartners}>
          Become a Partner
        </PartnerButton>
        <PartnerGrid partnerList={partnerList} />
      </Container>
    </Section>
  );
};

const Section = styled.section`
  padding: 300px 0 240px;
  text-align: center;

  h1 {
    margin-bottom: 85px;

    ${screen.below(bp.mobile, `
      margin: 0 auto 30px;
      max-width: 322px;
    `)}
  }

  p {
    max-width: 800px;
    margin-left: auto;
    margin-right: auto;
  }

  ${screen.below(bp.desktop, `
    padding: 225px 0 180px;
  `)}

  ${screen.below(bp.tablet, `
    padding: 168px 0 192px;
  `)}

  ${screen.below(bp.tablet, `
    padding: 154px 0 90px;
  `)}
`;

const PartnerButton = styled(Button)`
  margin-top: 40px;
`;

PartnersSection.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  partnerList: PropTypes.array,
};

export default PartnersSection;
